module.exports = __webpack_public_path__ + "static/media/top-view.d5e91cb7.png";